<div class="scroll-container">
  <div class="selection-line" [class.align-start]="align === 'start'" [class.align-end]="align === 'end'">
    <ng-content></ng-content>
  </div>
</div>
